import { createListenerMiddleware } from '@reduxjs/toolkit'

import AuthenticationStorage from '../../../shared/core/services/authentication-token'
import { setToken } from '../../slices/authentication-slice'

const authenticationSetTokenListener = createListenerMiddleware()

authenticationSetTokenListener.startListening({
  actionCreator: setToken,
  async effect({ payload: token }) {
    AuthenticationStorage.save(token)
    AuthenticationStorage.initialize()
  }
})

export default authenticationSetTokenListener
